import React from "react";
import { EconomyDataItem, SimulationType, ECONOMY_CARD_LABELS } from "../types";
import { formatBrazilianCurrency } from "../../../utils/utilityFunctions";

interface EconomyCardsProps {
  economyData: EconomyDataItem[];
  simulationType: SimulationType;
  quantidadeAnos: number;
}

const fmtPct = (value: number) =>
  value.toLocaleString("pt-BR", { style: "percent" });

export function EconomyCards({
  economyData,
  simulationType,
  quantidadeAnos,
}: EconomyCardsProps) {
  const labels = ECONOMY_CARD_LABELS[simulationType];

  return (
    <>
      {economyData.map(
        (e, i) =>
          i < quantidadeAnos && (
            <React.Fragment key={i}>
              <div style={{ marginTop: "16px" }}>
                <span className="simulacao-form-header">{e.ano}</span>
                <hr />
              </div>

              <div className="resultadoSimulacaoContainer2">
                <div className="economia-card2">
                  <h1>{labels.first}</h1>
                  <h2>{formatBrazilianCurrency(e.firstTotal)}</h2>
                </div>

                <div className="economia-card2">
                  <h1>{labels.second}</h1>
                  <h2>{formatBrazilianCurrency(e.secondTotal)}</h2>
                </div>

                <div className="economia-card2">
                  <h1>Economia mensal</h1>
                  <div className="economia-value">
                    <h2>{formatBrazilianCurrency(e.economia)}</h2>
                    <h3
                      className={
                        e.economia >= 0
                          ? "economia-positivo"
                          : "economia-negativo"
                      }
                    >
                      {fmtPct(e.economiaPct)}
                    </h3>
                  </div>
                </div>

                <div className="economia-card2">
                  <h1>Economia anual</h1>
                  <div className="economia-value">
                    <h2>{formatBrazilianCurrency(e.economiaAnual)}</h2>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )
      )}
    </>
  );
}
